import WranggleRpc from './core';
import LocalObserverTransport from "./local-observer-transport";
import registerShortcuts from './register-shortcuts';
registerShortcuts();
export default WranggleRpc;
export { WranggleRpc, LocalObserverTransport, };
export * from './interfaces';
//# sourceMappingURL=index.js.map